export const addAuthToLocalStorage = (payload: any) => {
  const { token, ...otherInfo } = payload;
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(otherInfo.user));
};

export const removeAuthFromLocalStorage = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getAuthFromLocalStorage = () => {
  const tempUser = localStorage.getItem('user') || null;

  let user = null;

  try {
    user = tempUser ? JSON.parse(tempUser) : null;
  } catch (e) {
    console.log(e);
    removeAuthFromLocalStorage();
  }
  return {
    token: localStorage.getItem('token') || '',
    user,
  };
};
